import { type MoneyMapApexBackdoorRothRole } from '../money-map/MoneyMap';
import {
    type ApexAccountRealtimeBalanceData,
    type ContributionConstraints,
    type ContributionSummary,
    type Enrollment,
} from './investment';
import {
    type ApexAccountState,
    type ApexDerivedSubState,
    type Portfolio,
    type RiskLevel,
    type SupportedApexAccountRegistrationType,
    type TimeHorizon,
} from './InvestmentManagementAccount';

export interface Entitlement {
    displayName?: string | undefined;
    entitlementCode?: string | undefined;
    lastModifiedReason?: string | undefined;
    lastModifiedTime?: Date | null | undefined;
    parentEntitlements?: string[] | undefined;
    state?: EntitlementState | undefined;
}

export enum EntitlementState {
    EntitlementStateUnspecified = 'ENTITLEMENT_STATE_UNSPECIFIED',
    Granted = 'GRANTED',
    Suspended = 'SUSPENDED',
    Denied = 'DENIED',
}

export interface ImAccount {
    apexAccountId: string;
    accountNumber: string;
    realtimeBalanceData: ApexAccountRealtimeBalanceData;
    contributionSummaries: ContributionSummary[];
    contributionConstraints: ContributionConstraints | null;
    nickname: string;
    color: string | null;
    icon: string | null;
    apexPortfolio: Portfolio;
    apexRiskLevel: RiskLevel;
    apexTimeHorizon: TimeHorizon;
    enrollments: Enrollment[];
    registrationType: SupportedApexAccountRegistrationType; // Enum
    ownershipType: string; // Enum
    state: ApexAccountState; // Enum
    createdAt: string;
    isRetirementAccount: boolean;
    canDepositFunds: boolean;
    canWithdrawFunds: boolean;
    derivedSubState: ApexDerivedSubState;
    backdoorRothRole: MoneyMapApexBackdoorRothRole | null;
    backdoorRothPairedApexAccountId?: string | null;
    autoConvert?: boolean | null;
}
